import { iwalyNotify } from '@/notify';
import {
  serviceCategoriesAttach,
  serviceCategories,
  createServiceCategory,
  updateServiceCategory,
  deleteServiceCategory,
  createService,
  updateService,
  deleteService,
  createServiceOption,
  updateServiceOption,
  deleteServiceOption,
  reorderServiceCategories,
  reorderCategoryServices,
} from '@/api/services';
import {
  SET_SERVICE_CATEGORIES_ATTACH,
  SET_SERVICE_CATEGORIES,
  UPDATE_SERVICE_CATEGORY,
  PUSH_SERVICE_CATEGORY,
  DELETE_SERVICE_CATEGORY,
  SET_CATEGORY_SERVICE_ARCHIVE,
  SET_CATEGORY_ARCHIVE,
  REORDER_SERVICE_CATEGORIES,
  REORDER_CATEGORY_SERVICES,
} from '@/store/modules/services/mutation-types';

export default {
  state: {
    categories: [],
    attach: [],
  },
  getters: {
    category: (state) => (id) => {
      if (typeof id !== 'undefined') {
        return state.categories.find((obj) => obj.id === parseInt(id, 10)) || null;
      }
      return state.categories;
    },
    activeServiceCategories: (state) => state.categories.filter((cat) => !cat.archive),
  },
  actions: {
    ACT_FETCH_SERVICE_CATEGORIES_ATTACH: async ({
      commit,
      dispatch,
    }) => {
      dispatch('wait/start', 'fetch.service.categories.attach', { root: true });
      return serviceCategoriesAttach().then((response) => {
        if (response.status === 200) {
          commit(SET_SERVICE_CATEGORIES_ATTACH, response.data);
        }
      }, (error) => {
        console.log(error);
      }).finally(() => {
        dispatch('wait/end', 'fetch.service.categories.attach', { root: true });
      });
    },
    ACT_FETCH_SERVICE_CATEGORIES: async ({
      commit,
      dispatch,
    }) => {
      dispatch('wait/start', 'fetch.service.categories', { root: true });
      return serviceCategories().then((response) => {
        if (response.status === 200) {
          commit(SET_SERVICE_CATEGORIES, response.data);
        }
      }).finally(() => {
        dispatch('wait/end', 'fetch.service.categories', { root: true });
      });
    },
    ACT_SAVE_SERVICE_CATEGORIES_ORDER: async ({ dispatch }, ids) => reorderServiceCategories(ids)
      .then((response) => {
        if (response.status === 200) {
          iwalyNotify.success({
            text: 'Порядок категорий сохранён!',
          });
        }
        return response;
      })
      .catch((error) => {
        iwalyNotify.error({
          text: 'Не удалось сохранить порядок категорий.',
        });
        dispatch('ACT_FETCH_SERVICE_CATEGORIES');
        throw error;
      }),
    ACT_SAVE_CATEGORY_SERVICES_ORDER: async ({ dispatch }, { categoryId, ids }) => reorderCategoryServices(categoryId, ids)
      .then((response) => {
        if (response.status === 200) {
          iwalyNotify.success({
            text: 'Порядок услуг сохранён!',
          });
        }
        return response;
      })
      .catch((error) => {
        iwalyNotify.error({
          text: 'Не удалось сохранить порядок услуг.',
        });
        dispatch('ACT_FETCH_SERVICE_CATEGORIES');
        throw error;
      }),
    ACT_CREATE_SERVICE_CATEGORY: async ({ commit }, payload) => new Promise((resolve, reject) => {
      createServiceCategory(payload).then((response) => {
        if (response.status === 200) {
          commit(PUSH_SERVICE_CATEGORY, payload);
          iwalyNotify.success({
            text: 'Категория успешно создана!',
          });
          resolve(response);
        }
      }, (error) => {
        console.log(error);
        reject(error);
      });
    }),
    ACT_UPDATE_SERVICE_CATEGORY: async ({ commit }, payload) => new Promise((resolve, reject) => {
      updateServiceCategory(payload).then((response) => {
        if (response.status === 200) {
          commit(UPDATE_SERVICE_CATEGORY, payload);
          iwalyNotify.success({
            text: 'Изменения успешно внесены!',
          });
          resolve(response);
        }
      }, (error) => {
        console.log(error);
        reject(error);
      });
    }),
    ACT_DELETE_SERVICE_CATEGORY: async ({ commit }, payload) => new Promise((resolve, reject) => {
      deleteServiceCategory(payload).then((response) => {
        if (response.status === 200) {
          commit(DELETE_SERVICE_CATEGORY, payload);
          iwalyNotify.success({
            text: 'Категория успешно удалена!',
          });
          resolve(response);
        }
      }, (error) => {
        console.log(error);
        reject(error);
      });
    }),
    ACT_CREATE_SERVICE: async (_, payload) => new Promise((resolve, reject) => {
      createService(payload).then((response) => {
        if (response.status === 200) {
          iwalyNotify.success({
            text: 'Услуга успешно создана!',
          });
          resolve(response);
        }
      }, (error) => {
        console.log(error);
        reject(error);
      });
    }),
    ACT_UPDATE_SERVICE: async (_, payload) => new Promise((resolve, reject) => {
      updateService(payload).then((response) => {
        if (response.status === 200) {
          iwalyNotify.success({
            text: 'Данные успешно изменены!',
          });
          resolve(response);
        }
      }, (error) => {
        console.log(error);
        reject(error);
      });
    }),
    ACT_DELETE_SERVICE: async ({ dispatch }, payload) => new Promise((resolve, reject) => {
      deleteService(payload).then((response) => {
        if (response.status === 200) {
          resolve(response);
          dispatch('ACT_FETCH_SERVICE_CATEGORIES');
        }
      }, (error) => {
        console.log(error);
        reject(error);
      });
    }),
    ACT_CREATE_SERVICE_OPTION: async (_, payload) => new Promise((resolve, reject) => {
      createServiceOption(payload).then((response) => {
        if (response.status === 200) {
          resolve(response);
        }
      }, (error) => {
        console.log(error);
        reject(error);
      });
    }),
    ACT_UPDATE_SERVICE_OPTION: async (_, payload) => new Promise((resolve, reject) => {
      updateServiceOption(payload).then((response) => {
        if (response.status === 200) {
          resolve(response);
        }
      }, (error) => {
        console.log(error);
        reject(error);
      });
    }),
    ACT_DELETE_SERVICE_OPTION: async (_, payload) => new Promise((resolve, reject) => {
      deleteServiceOption(payload).then((response) => {
        if (response.status === 200) {
          resolve(response);
        }
      }, (error) => {
        console.log(error);
        reject(error);
      });
    }),
    ACT_ACTIVATE_CATEGORY: async ({ dispatch, commit, state }, categoryId) => {
      const category = state.categories.find((cat) => +cat.id === +categoryId);
      if (category) {
        return dispatch('ACT_UPDATE_SERVICE_CATEGORY', {
          ...category,
          archive: false,
        }).then(() => {
          commit(SET_CATEGORY_ARCHIVE, {
            categoryId,
            value: false,
          });
        });
      }
      return Promise.reject();
    },
    ACT_DEACTIVATE_CATEGORY: async ({ dispatch, commit, state }, categoryId) => {
      const category = state.categories.find((cat) => +cat.id === +categoryId);
      if (category) {
        return dispatch('ACT_UPDATE_SERVICE_CATEGORY', {
          ...category,
          archive: true,
        }).then(() => {
          commit(SET_CATEGORY_ARCHIVE, {
            categoryId,
            value: true,
          });
        });
      }
      return Promise.reject();
    },
    ACT_ACTIVATE_CATEGORY_SERVICE: async ({ dispatch, commit }, {
      categoryId,
      serviceId,
    }) => dispatch('ACT_UPDATE_SERVICE', {
      id: categoryId,
      serviceId,
      archive: false,
    }).then(() => {
      commit(SET_CATEGORY_SERVICE_ARCHIVE, {
        categoryId,
        serviceId,
        value: false,
      });
    }),
    ACT_DEACTIVATE_CATEGORY_SERVICE: async ({ dispatch, commit }, {
      categoryId,
      serviceId,
    }) => dispatch('ACT_UPDATE_SERVICE', {
      id: categoryId,
      serviceId,
      archive: true,
    }).then(() => {
      commit(SET_CATEGORY_SERVICE_ARCHIVE, {
        categoryId,
        serviceId,
        value: true,
      });
    }),
  },
  mutations: {
    [SET_SERVICE_CATEGORIES](state, data) {
      state.categories = data;
    },
    [PUSH_SERVICE_CATEGORY](state, data) {
      state.categories = [...state.categories, data];
    },
    [DELETE_SERVICE_CATEGORY](state, id) {
      state.categories = state.categories.filter((el) => el.id !== id);
    },
    [UPDATE_SERVICE_CATEGORY](state, data) {
      const updatedCategories = state.categories.map((el) => {
        let result = {};
        if (el.id === data.id) {
          result = {
            ...el,
            iconAttach: data.iconAttach,
            v2IconAttach: data.v2IconAttach,
          };
          return result;
        }
        return el;
      });
      state.categories = [...updatedCategories];
    },
    [REORDER_SERVICE_CATEGORIES](state, ids) {
      const categoriesById = state.categories.reduce((result, category) => ({
        ...result,
        [category.id]: category,
      }), {});

      const orderedCategories = ids
        .map((id, index) => {
          const category = categoriesById[id];
          if (!category) return null;
          return {
            ...category,
            sortOrder: index + 1,
          };
        })
        .filter(Boolean);
      const orderedIds = ids.map((id) => +id);
      const remainingCategories = state.categories.filter(
        (category) => !orderedIds.includes(+category.id),
      );

      state.categories = [...orderedCategories, ...remainingCategories];
    },
    [REORDER_CATEGORY_SERVICES](state, { categoryId, ids }) {
      state.categories = state.categories.map((category) => {
        if (+category.id !== +categoryId) return category;

        const servicesById = (category.services || []).reduce((result, service) => ({
          ...result,
          [service.id]: service,
        }), {});

        return {
          ...category,
          services: [
            ...ids
              .map((id, index) => {
                const service = servicesById[id];
                if (!service) return null;
                return {
                  ...service,
                  sortOrder: index + 1,
                };
              })
              .filter(Boolean),
            ...(category.services || []).filter(
              (service) => !ids.map((id) => +id).includes(+service.id),
            ),
          ],
        };
      });
    },
    [SET_SERVICE_CATEGORIES_ATTACH](state, data) {
      state.attach = data;
    },
    [SET_CATEGORY_SERVICE_ARCHIVE](state, {
      categoryId,
      serviceId,
      value,
    }) {
      state.categories = state.categories.map((category) => {
        if (+category.id === +categoryId) {
          // eslint-disable-next-line no-param-reassign
          category.services = category.services.map((service) => {
            if (+service.id === +serviceId) {
              // eslint-disable-next-line no-param-reassign
              service.archive = !!value;
            }
            return service;
          });
        }
        return category;
      });
    },
    [SET_CATEGORY_ARCHIVE](state, {
      categoryId,
      value,
    }) {
      state.categories = state.categories.map((category) => {
        if (+category.id === +categoryId) {
          // eslint-disable-next-line no-param-reassign
          category.archive = !!value;
        }
        return category;
      });
    },
  },
  namespaced: true,
};
